export const formatPrice = (price: string | number): string => parseFloat(`${price}`).toLocaleString('fi-FI', { style: 'currency', currency: 'EUR' })
export const calculateDiscountPercent = (price: number, finalPrice: number): number => Math.round(100 - ((finalPrice / price) * 100))
